import React from 'react';
import Success from '../../ui/Success';

const Danke = () => {
	return <Success />;
}


export default Danke;